export const OPEN_STEPS_MODAL_COMPLETED = 'onboarding/OPEN_STEPS_MODAL_COMPLETED';
export const TOGGLE_IS_FETCHING = 'onboarding/TOGGLE_IS_FETCHING';
export const SITES_STATUS_CHANGE = 'onboarding/SITES_STATUS_CHANGE';
export const SET_DIALOG_COMPLETED = 'onboarding/SET_DIALOG_COMPLETED';
export const SET_ADD_CONTENT_MODAL = 'onboarding/SET_ADD_CONTENT_MODAL';

